import { PicturesIcon, VideoIcon } from '@capsicum/common-web/icons';
import { MODAL_TYPE_IMAGE, MODAL_TYPE_VIDEO, type ModalTypes } from '@capsicum/features/survey/shared';
import { type FC, type SVGProps } from 'react';

export const getModalIcon = (modalType: ModalTypes): FC<SVGProps<SVGSVGElement>> | null => {
	if (modalType === MODAL_TYPE_IMAGE) {
		return PicturesIcon;
	}

	if (modalType === MODAL_TYPE_VIDEO) {
		return VideoIcon;
	}

	return null;
};
